export default "__VITE_ASSET__CNJrirxU__"